import { RouteType } from "constants/RouteType";
import { BlogModel } from "model/screensModels/BlogModel";
import { FinancialProtectionModel } from "model/screensModels/FinancialProtectionModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { AuthService } from "services/auth/AuthService";

export class FinancialProtectionService {

  //To get Financial list
  static getFinancialList = async (requestBody: PaginatorModel| string) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION;
    const response = AuthService.postCryptoRequest(url, requestBody==='' ? '' : JSON.stringify(requestBody));
    return response;
  };

   //save Financial
   static addFinancialProtection = async (requestBody: FinancialProtectionModel) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION + RouteType.STORE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };


   // To Get The Update Of Membership Status

  //  static updateFinancialStatus = async (requestBody: FinancialProtectionModel) => {
  //   const url = RouteType.ADMIN + RouteType.UPDATE_FINANCIAL_STATUS;
  //   const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
  //   return response;
  // } 


  //delete Financial
  static deleteFinancial = async (requestBody: FinancialProtectionModel) => {
    const url = RouteType.ADMIN + RouteType.FINANCIAL_PROTECTION + RouteType.DELETE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };
}